module.exports = __webpack_public_path__ + "img/顺德职业技术学院.ef33a6b0.png";